<template>
    <div>
      <Teleport to="#settings-group-header">
        <T>Онлайн оплата</T>
        <div style="font-size: 0.85rem; color: gray;"><T>Настройка платежного агрегатора</T></div>
      </Teleport>  
  
      <Teleport to="#settings-group-actions">
        <v-btn test-tag="tag-296"
          text
          color="primary"
          @click="save"
          :loading="loading"
          :disabled="dis"
        >
          <v-icon>mdi-content-save</v-icon>
          <T>Сохранить</T>
        </v-btn>
      </Teleport>
      
      <Pay :loading="loading" :config="$store.getters.local_refs.pay_settings" ref="form"/>
    </div>
  </template>
  
  <script>
  
  import Teleport from 'vue2-teleport'
  import Pay from '../../components/settings/pay'
  
  
  export default {
    data: () => ({
      loading: false,
      dis: false
    }),
    methods: {
      async save(){
        this.loading = true
        try {
          const formData = this.$refs.form.submit()

          let rulesConf = { ...this.$store.getters.local_refs.rules_delivery }
          if (formData.pay_enable === false) {
            rulesConf.allow_pay_card_online = false
          }

          // let rulesConf = this.$store.getters.local_refs.rules_delivery
          // console.log('new_config', this.$refs.form.submit().pay_enable)

          let new_config = {
            pay_settings: formData,
            rules_delivery: rulesConf
          }
          
          await this.$store.dispatch('updateLocalRefs', new_config)
  
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: this.$t('Изменения сохранены'),
            message_class: 'success'
          })
  
        } catch (e) {
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: `${e.message}`,
            message_class: 'error'
          })
          this.loading = false
        } finally {
          this.loading = false
        }
      }
    },
    components: {
      Teleport,
      Pay
    }
  }
  </script>